var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sp-menu", class: { "sp-menu--open": _vm.mainMenuVisible } },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "sp-menu__content" }, [
          _c("p", { staticClass: "sp-menu__title" }, [
            _vm._v("BROWSE TOPICS BY:"),
          ]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "sp-menu__list" },
            [
              _c("li", { staticClass: "sp-menu__item" }, [
                _c(
                  "a",
                  {
                    staticClass: "sp-menu__link",
                    attrs: { href: _vm.baseLink },
                  },
                  [_vm._v("All")]
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.links, function (link) {
                return _c(
                  "li",
                  { key: link.id, staticClass: "sp-menu__item" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "sp-menu__link",
                        attrs: { href: link.href },
                      },
                      [_vm._v(_vm._s(link.title))]
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }